import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import appReducer, { namespace as appNamespace } from './modules/app';
import authReducer, { namespace as authNamespace } from './modules/auth';
import homeReducer, { namespace as homeNamespace } from './modules/home';
import profileReducer, { namespace as profileNamespace } from './modules/profile';
import marketplaceReducer, { namespace as marketplaceNamespace } from './modules/marketplace';
import clueReducer, { namespace as clueNamespace } from './modules/clue';
import clueTenStepReducer, { namespace as clueTenStepNamespace } from './modules/clueTenStep';
import transactionReducer, { namespace as transactionNamespace } from './modules/transaction';
import rewardReducer, { namespace as rewardItems } from './modules/reward-items';
import placeArTreasureReducer, {
  namespace as placeArTreasureNamespace,
} from './modules/placeArTreasure';
import treasureManagementReducer, {
  namespace as treasureManagementNamespace,
} from './modules/treasureManagement';
import swapPointForCryptoReducer, {
  namespace as swapPointForCryptoNamespace,
} from './modules/swapPointForCrypto';

import otpVerificationReducer, {
  namespace as otpVerificationNamespace,
} from './modules/otpVerification';

import buyPointForHuntReducer, {
  namespace as buyPointForHuntNamespace,
} from './modules/buyPointForHunt';

import resetPasswordReducer, { namespace as resetPasswordNamespace } from './modules/resetPassword';
import countryReducer, { namespace as countryNamespace } from './modules/country';
import goldBarReducer, { namespace as goldBarNamespace } from './modules/goldbar';
import socketReducer, { namespace as socketNamespace } from './modules/socket';
import shareLinkReducer, { namespace as shareLinkNamespace } from './modules/shareLink';
import uploadFileReducer, { namespace as uploadFileNamespace } from './modules/uploadFile';
import plansReducer, { namespace as plansNamespace } from './modules/plans';
import fcmReducer, { namespace as fcmNamespace } from './modules/fcm';
import userNotificationsReducer, {
  namespace as userNotificationsNamespace,
} from './modules/userNotifications';
import merchandiseReducer, {
  namespace as merchandiseNamespace,
} from './modules/merchandise';
import wishlistReducer, { namespace as wishlistNamespace } from './modules/wishlist';

const rootReducer = (extraReducers) =>
  combineReducers({
    [wishlistNamespace]: wishlistReducer,
    [authNamespace]: authReducer,
    [appNamespace]: appReducer,
    form: formReducer,
    [profileNamespace]: profileReducer,
    [marketplaceNamespace]: marketplaceReducer,
    [homeNamespace]: homeReducer,
    [clueNamespace]: clueReducer,
    [transactionNamespace]: transactionReducer,
    [placeArTreasureNamespace]: placeArTreasureReducer,
    [treasureManagementNamespace]: treasureManagementReducer,
    [swapPointForCryptoNamespace]: swapPointForCryptoReducer,
    [otpVerificationNamespace]: otpVerificationReducer,
    [clueNamespace]: clueReducer,
    [clueTenStepNamespace]: clueTenStepReducer,
    [transactionNamespace]: transactionReducer,
    [placeArTreasureNamespace]: placeArTreasureReducer,
    [swapPointForCryptoNamespace]: swapPointForCryptoReducer,
    [otpVerificationNamespace]: otpVerificationReducer,
    [buyPointForHuntNamespace]: buyPointForHuntReducer,
    [marketplaceNamespace]: marketplaceReducer,
    [resetPasswordNamespace]: resetPasswordReducer,
    [countryNamespace]: countryReducer,
    [goldBarNamespace]: goldBarReducer,
    [socketNamespace]: socketReducer,
    [rewardItems]: rewardReducer,
    [shareLinkNamespace]: shareLinkReducer,
    [uploadFileNamespace]: uploadFileReducer,
    [plansNamespace]: plansReducer,
    [fcmNamespace]: fcmReducer,
    [userNotificationsNamespace]: userNotificationsReducer,
    [merchandiseNamespace]: merchandiseReducer,
    ...extraReducers,
  });

export default rootReducer;
